import apiService from '../../apiService'
import { generalApiPrefix } from '@const'

export default {
  // 校验是否有代报名权限
  checkAgentAuth: (
    trainingClassId: string
  ): Promise<any> =>
    apiService.get(`${generalApiPrefix}/trainingclass/enroll/record/checkAgentAuth.do`, {
      trainingClassId
    }),
  // 培训班代报名列表
  getAgencyEnrollList: (
    trainingClassId: string,
    isEnroll: number // 1：已报名 2：未报名
  ): Promise<any> =>
    apiService.get(`${generalApiPrefix}/trainingclass/enroll/record/list.do`, {
      trainingClassId,
      isEnroll
    }),
  // 培训班代报名
  agencyEnroll: (data: any): Promise<any> =>
    apiService.post(`${generalApiPrefix}/trainingclass/enroll/record/agentEnroll.do`, data),
  // 培训班取消代报名
  cancelEnroll: (data: any): Promise<any> =>
    apiService.post(`${generalApiPrefix}/trainingclass/enroll/record/cancelEnroll.do`, data),
}
